import { Checkbox, Flex, Form, FormInstance, Input, Typography } from "antd";
import { RuleObject } from "antd/es/form";
import { StoreValue } from "antd/es/form/interface";
import { get } from "lodash";
import { memo, useCallback } from "react";
import { weekDays } from "utils/constants";
import TimeRangeInput from "./datePikerForSchedule";
import TimeInput from "./timeInput";

const validateDays = (_: RuleObject, value: StoreValue) => {
  let hasAtLeastOneSelected = false;

  for (const key in value) {
    if (value && get(value, `${key}.selected`)) {
      hasAtLeastOneSelected = true;
      break;
    }
  }

  if (hasAtLeastOneSelected) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Please select at least one day."));
};

interface IProps {
  form: FormInstance;
}

const WorkingHours = ({ form }: IProps) => {
  const days = Form.useWatch("days", form);

  const handleDayChange = useCallback(
    (checked: boolean, index: number) => {
      if (!checked) {
        form.setFieldValue(["days", weekDays[index], "workingHour"], undefined);
        form.setFieldValue(
          ["days", weekDays[index], "workingHours"],
          undefined
        );
        form.setFieldValue(
          ["days", weekDays[index], "breakingHours"],
          undefined
        );
      } else if (days[weekDays[index - 1]]) {
        form.setFieldValue(
          ["days", weekDays[index], "workingHour"],
          get(days[weekDays[index - 1]], "workingHour")
        );
        form.setFieldValue(
          ["days", weekDays[index], "workingHours"],
          get(days[weekDays[index - 1]], "workingHours")
        );
        form.setFieldValue(
          ["days", weekDays[index], "breakingHours"],
          get(days[weekDays[index - 1]], "breakingHours")
        );
      }
      form.validateFields(["days"]);
    },
    [form, days]
  );

  console.log("days",days);

  return (
    <>
      <Flex justify="flex-end" className="gap-5">
        <Typography.Text className="w-48">Overall hours</Typography.Text>
        <Typography.Text className="w-48">Working hours</Typography.Text>
        <Typography.Text className="w-48">Breaking hours</Typography.Text>
      </Flex>

      <Form.Item name="days" rules={[{ validator: validateDays }]}>
        {weekDays.map((day, index) => (
          <div
            key={day}
            className="bg-slate-100 rounded-md p-2 gap-5 mb-3 flex items-center days"
          >
            <Form.Item
              name={["days", day, "selected"]}
              valuePropName="checked"
              className="mb-0"
            >
              <Checkbox
                onChange={(event) =>
                  handleDayChange(event.target.checked, index)
                }
              />
            </Form.Item>

            <Typography.Text
              className="flex-1 "
              style={{ textTransform: "capitalize" }}
            >
              {day.toLowerCase()}
            </Typography.Text>

            <Form.Item
              className="mb-0 w-48"
              name={["days", day, "workingHour"]}
              rules={[
                {
                  required: get(days, `${day}.selected`),
                  message: "Please enter overall working hours!",
                },
              ]}
            >
              <TimeInput disabled={!get(days, `${day}.selected`)} />
            </Form.Item>
            <Form.Item
              name={["days", day, "workingHours"]}
              className="mb-0 w-48"
              rules={[
                {
                  required: get(days, `${day}.selected`),
                  message: "Please enter working hours!",
                },
              ]}
            >
              <TimeRangeInput disabled={!get(days, `${day}.selected`)} />
            </Form.Item>

            <Form.Item
              name={["days", day, "breakingHours"]}
              className="mb-0 w-48"
              rules={[
                {
                  required: get(days, `${day}.selected`),
                  message: "Please enter breaking hours!",
                },
              ]}
            >
              <TimeRangeInput disabled={!get(days, `${day}.selected`)} />
            </Form.Item>

            <Form.Item hidden name={["days", day, "id"]}>
              <Input />
            </Form.Item>
          </div>
        ))}
      </Form.Item>
    </>
  );
};

export default memo(WorkingHours);
